import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MOT_MANAGE_VACATIONS_REPOSITORY,
  MotManageVacationsRepository
} from '@app/domain/repositories/manage-vacations/mot/mot-manage-vacations.repository.contract';
import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import { ManageVacationsCriteria } from '@app/entities/models/manage-vacations/manage-vacations-criteria.model';
import {
  EmployeeObservations,
  SeasonCalendar,
  VacationsSeason
} from '@app/entities/models/manage-vacations/manage-vacations.model';
import {
  MotFactoryProposal,
  MotVacationsProposal
} from '@app/entities/models/manage-vacations/mot-manage-vacations.model';
import { TUserTypeCalendarProposal } from '@app/entities/types/manage-vacations.type';

import { MotManageVacationsUseCases } from './mot-manage-vacations.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class MotManageVacationsUseCasesImpl implements MotManageVacationsUseCases {
  #manageVacationsRepository: MotManageVacationsRepository = inject(MOT_MANAGE_VACATIONS_REPOSITORY);

  getProposals(): Observable<MotVacationsProposal> {
    return this.#manageVacationsRepository.getProposals();
  }

  getVacationsCriteria(): Observable<ManageVacationsCriteria> {
    return this.#manageVacationsRepository.getVacationsCriteria();
  }

  getVacationsSeason(): Observable<VacationsSeason> {
    return this.#manageVacationsRepository.getVacationsSeason();
  }

  getSeasonCalendar(season: SEASONS): Observable<SeasonCalendar<TUserTypeCalendarProposal>> {
    return this.#manageVacationsRepository.getSeasonCalendar(season);
  }

  createProposal(
    proposals: MotVacationsProposal,
    storedProposals: MotFactoryProposal[],
    isSummerSeason: boolean
  ): Observable<MotVacationsProposal> {
    return this.#manageVacationsRepository.createProposal(proposals, storedProposals, isSummerSeason);
  }

  updateObservations(observations: EmployeeObservations): Observable<EmployeeObservations> {
    return this.#manageVacationsRepository.updateObservations(observations);
  }
}
